module.exports = __webpack_public_path__ + "static/media/pricelist-banner@2x.3d43b612.jpg";